(() => {
  if (window.__tretmaschineReputonSyncActive) return;
  window.__tretmaschineReputonSyncActive = true;

  const retryDelays = [250, 750, 1500, 3000, 6000, 10000];
  let retryTimers = [];
  let cachedRating = '';
  let cachedCount = '';

  const stopRetries = () => {
    retryTimers.forEach((timer) => window.clearTimeout(timer));
    retryTimers = [];
  };

  const syncRating = () => {
    const target = document.querySelector('#header-component .tret-ci-reputon-live');
    if (!target) return false;

    const sources = document.querySelectorAll('.reputon-google-reviews-widget[initialized]');
    for (const source of sources) {
      const rating = source.querySelector('.reputon-count-number')?.textContent?.trim();
      const countText = source.querySelector('.reputon-reviews-count')?.textContent?.trim();
      const count = countText?.match(/\d[\d.,\s]*/)?.[0]?.replace(/\s+/g, '');
      if (!rating || !count) continue;

      cachedRating = rating;
      cachedCount = count;
      break;
    }

    if (!cachedRating || !cachedCount) return false;

    const ratingNode = target.querySelector('[data-reputon-rating]');
    const countNode = target.querySelector('[data-reputon-count]');
    if (!ratingNode || !countNode) return false;

    const formattedCount = `(${cachedCount})`;
    const ariaLabel = `Google-Bewertung ${cachedRating} von 5 Sternen bei ${cachedCount} Bewertungen`;

    if (ratingNode.textContent !== cachedRating) ratingNode.textContent = cachedRating;
    if (countNode.textContent !== formattedCount) countNode.textContent = formattedCount;
    if (target.getAttribute('aria-label') !== ariaLabel) target.setAttribute('aria-label', ariaLabel);
    if (!target.classList.contains('is-ready')) target.classList.add('is-ready');

    return true;
  };

  const startSync = () => {
    stopRetries();

    syncRating();

    retryTimers = retryDelays.map((delay) => window.setTimeout(() => {
      syncRating();
    }, delay));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startSync, { once: true });
  } else {
    startSync();
  }

  window.addEventListener('load', startSync, { once: true });
  window.addEventListener('pageshow', startSync);
  document.addEventListener('tm:reviews-loaded', startSync);
  document.addEventListener('shopify:section:load', startSync);
})();

